import { SENTRY_DSN } from '@/env'
import '@/utils/dayjs'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import { MissionsApp } from './missions-app/MissionsApp'

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    allowUrls: [/https?:\/\/(dashboard|api)\.datahive\.ai/],
    denyUrls: [/chrome-extension:\/\//i, /moz-extension:\/\//i],
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/datahive\.ai\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

const appContainer = document.getElementById('app')
if (appContainer) {
  ReactDOM.createRoot(appContainer).render(<MissionsApp />)
}
